module.exports = __webpack_public_path__ + "img/Soy.003b6780.png";